import { toast } from "react-toastify";
import axios from "../services/api/api";
import { formatServiceError } from "./serviceErrorHelper";
import { TOAST_CONFIG } from "./toastConfig";

// Resultattexten kan vara lång (varning om programlicenser), så den får stå kvar längre.
const MOVE_TOAST_CONFIG = { ...TOAST_CONFIG, autoClose: 8000 };

// Flyttar en elev till en klass eller en lärare till en eller flera klasser på samma skola,
// och visar resultatet som toasts. Med teacherOnly nekar servern att flytta en elev.
// Returnerar true när servern svarade utan fel, annars false.
export const moveUserToClasses = async (
  intl,
  userEmail,
  classIds,
  teacherOnly = false,
) => {
  try {
    const response = await axios.post("/User/Move", {
      userEmail,
      toClassIds: classIds,
      teacherOnly,
    });
    const result = response?.data?.result;

    if (result?.name) {
      toast.success(
        intl.formatMessage(
          {
            id:
              result.userType === "Teacher"
                ? "MoveUserDoneTeacher"
                : "MoveUserDoneStudent",
          },
          {
            name: result.name,
            className:
              result.classCount > 1
                ? intl.formatMessage(
                    { id: "ClassCount" },
                    { count: result.classCount },
                  )
                : result.className,
            schoolName: result.schoolName,
            restored: String(result.restored),
          },
        ),
        TOAST_CONFIG,
      );

      if (result.missingProgramLicenses) {
        toast.warn(
          intl.formatMessage({ id: "MoveUserMissingProgramLicenses" }),
          MOVE_TOAST_CONFIG,
        );
      }
    } else {
      toast.warn(
        intl.formatMessage({ id: "ServerResponseUnexpected" }),
        MOVE_TOAST_CONFIG,
      );
    }

    return true;
  } catch (err) {
    toast.warn(
      formatServiceError(intl, err?.response?.data),
      MOVE_TOAST_CONFIG,
    );

    return false;
  }
};
